import React from 'react';
import { useDimensions } from '../logic/Dimentions'
import { useSeasonal } from '../logic/Seasonal'
import CommonLayout from '../components/Layouts/CommonLayout';
import SocialMediaWrap from '../components/SocailMediaIcons'
import AllPastVideos from '../components/AllPastVideos';

const AllPastVideosPage = () => {
    const { width } = useDimensions()
    const { classes } = useSeasonal()

    return (
        <CommonLayout>
            <AllPastVideos />
            {width >= 992 && <SocialMediaWrap classes={classes} />}
        </CommonLayout>

    )
}
export default AllPastVideosPage;